import React, { useState, useEffect } from 'react'
import { COMPANY_DETAILS, SAVE_LOGO } from '../../../../data/url';
import httpClient from '../../../../http/HttpRequest';
import Alert from '../../../../feature/Alert';
import { IMAGE_PATH } from '../../../../data/constant';
import { useTranslation } from 'react-i18next';

export default function CompanyLogo() {
     const [logo, setlogo] = useState(null);
     const [favicon, setfavicon] = useState(null);
     const [companyData, setcompanyData] = useState({});
     const { t } = useTranslation();

     const handleImageChange = (e, setImage) => {
          const imageFile = e.target.files[0];
          setImage(imageFile);
     };

     const handleUpload = async () => {
          const formData = new FormData();
          if (logo) formData.append('logo', logo);
          if (favicon) formData.append('favicon', favicon);
          formData.append('company_id', companyData.company_id);
          const res = await httpClient.upload(SAVE_LOGO, formData);
          if (res.requestStatus === 'OK') {
               const result = res.result;
               if (result.status === 1) {
                    Alert.success(result.message);
               } else {
                    Alert.error(result.message);
               }
          }
     };

     useEffect(() => {
          getCompanyDetails();       
     }, []);

     const getCompanyDetails = async () => {
          const res = await httpClient.post(COMPANY_DETAILS, {});
          if (res.requestStatus === 'OK') {
               const result = res.result;
               if (result.status === 1) {
                    setcompanyData(result.data);
               } else {
                    Alert.error(result.message);
               }
          }
     };     

     return (
          <div className='col-md-8 m-auto'>
               <div className='row'>
                    <div className='col-md-6'>
                         <div className='form-group'>
                              <label>{t('logo')}</label>
                              <input
                                   type="file"
                                   accept="image/*"
                                   onChange={(e) => handleImageChange(e, setlogo)}
                                   className='form-control'
                              />
                         </div>
                    </div>
                    <div className='col-md-6'>
                         <div className='form-group'>
                              <label>{t('favicon')}</label>
                              <input
                                   type="file"
                                   accept="image/*"
                                   onChange={(e) => handleImageChange(e, setfavicon)}
                                   className='form-control'
                              />
                         </div>
                    </div>
                    <div className='col-md-6 text-center'>
                         {companyData.logo && (
                              <img
                                   src={`${IMAGE_PATH}/logo/${companyData.logo}`}
                                   alt="First Selected"                                   
                              />
                         )}
                    </div>

                    <div className='col-md-6 text-center'>
                         {companyData.favicon && (
                              <img
                                   src={`${IMAGE_PATH}/logo/${companyData.favicon}`}
                                   alt="Second Selected"                                   
                              />
                         )}
                    </div>
               </div>
               <div className='text-center'>
                    <button className='btn btn-primary' onClick={handleUpload}>{t('upload')}</button>
               </div>
          </div>
     );
}
